/*
 *
 * QualitativeQuestionList actions
 *
 */

import {
  GET_QUALITATIVE_ANSWERS_WATCHER,
  GET_QUALITATIVE_ANSWERS_SUCCESS,
  GET_QUALITATIVE_ANSWERS_FAILED,
} from "./constants"

/* Anwers */
export function getQualitativeAnswersWatcher(payload) {
  return {
    type: GET_QUALITATIVE_ANSWERS_WATCHER,
    payload,
  }
}

export function getQualitativeAnswersSuccess(payload) {
  return {
    type: GET_QUALITATIVE_ANSWERS_SUCCESS,
    payload,
  }
}

export function getQualitativeAnswersFailed() {
  return { type: GET_QUALITATIVE_ANSWERS_FAILED }
}
